import { License } from '../../api/api-generated';
import {
  numbersMatch,
  stringIncludesIgnoreCase,
} from '../../utils/comparisons';
import { truncateISOString, hasDatePassed } from '../../utils/dateTime';
import { SoftwareSoldItemFilter } from './softwareSoldTypes';
import { useGetMostRecentSupportPurchase } from './useGetMostRecentSupportPurchase';

export const useGetLicenseFilter = () => {
  const getMostRecentSupportPurchase = useGetMostRecentSupportPurchase();
  return (item: License, filters: SoftwareSoldItemFilter): boolean => {
    const currentSupportRecord = getMostRecentSupportPurchase(item);
    if (
      filters.hardwareType &&
      !numbersMatch(filters.hardwareType.id, item.hardware.hardwareTypeId)
    )
      return false;
    if (
      filters.company &&
      !stringIncludesIgnoreCase(
        item.company.companyName,
        filters.company.companyName
      )
    )
      return false;
    if (
      filters.software &&
      !stringIncludesIgnoreCase(item.software.type, filters.software.type)
    )
      return false;
    if (
      filters.serial &&
      !stringIncludesIgnoreCase(item.hardware.serial, filters.serial)
    )
      return false;
    if (
      filters.soldDateFrom &&
      (item.order === null ||
        truncateISOString(item.order.orderDate) <
          truncateISOString(filters.soldDateFrom))
    )
      return false;
    if (
      filters.soldDateTo &&
      (item.order === null ||
        truncateISOString(item.order.orderDate) >
          truncateISOString(filters.soldDateTo))
    )
      return false;
    if (
      (filters.supportStartTo || filters.supportStartFrom) &&
      !currentSupportRecord
    )
      return false;
    if (
      filters.supportStartFrom &&
      (!currentSupportRecord ||
        currentSupportRecord.supportStartDate === null ||
        truncateISOString(currentSupportRecord.supportStartDate) <
          truncateISOString(filters.supportStartFrom))
    )
      return false;
    if (
      filters.supportStartTo &&
      (!currentSupportRecord ||
        currentSupportRecord.supportStartDate === null ||
        truncateISOString(currentSupportRecord.supportStartDate) >
          truncateISOString(filters.supportStartTo))
    )
      return false;

    if (filters.supportStatus) {
      switch (filters.supportStatus) {
        case 'Active':
          if (
            !currentSupportRecord ||
            !currentSupportRecord.supportEndDate ||
            hasDatePassed(new Date(currentSupportRecord.supportEndDate))
          )
            return false;
          break;
        case 'Expired':
          if (
            !currentSupportRecord ||
            !currentSupportRecord.supportEndDate ||
            !hasDatePassed(new Date(currentSupportRecord.supportEndDate))
          )
            return false;
          break;
        default:
          if (currentSupportRecord) return false;
      }
    }
    return true;
  };
};
